class GoogleReviewsBlock {
    constructor(block) {
        this.block = block;
        this.allReviews = [];
        this.minRating = parseInt(block.dataset.minRating) || 0;
        this.init();
    }

    async init() {
        try {
            const response = await fetch('/wp-json/block-builder/v1/google-reviews');
            if (!response.ok) throw new Error('Failed to fetch reviews');
            
            const data = await response.json();
            this.allReviews = data.reviews || [];
            this.updateDOM(data);
        } catch (error) {
            // Error handling without logging
            this.handleError();
        }
    }

    handleError() {
        const errorContainer = document.createElement('div');
        errorContainer.className = 'google-reviews__error';
        errorContainer.innerHTML = '<p>Unable to load reviews</p>';
        this.block.appendChild(errorContainer);
    }

    updateDOM(data) {
        if (!data) return;

        // Update rating
        const ratingElement = this.block.querySelector('.google-reviews__score');
        if (ratingElement) {
            ratingElement.textContent = Number(data.rating).toFixed(1);
        }

        // Update review URL
        const linkElement = this.block.querySelector('.google-reviews__link');
        if (linkElement && data.reviewUrl) {
            linkElement.href = data.reviewUrl;
            linkElement.textContent = 'Google Reviews';
        }

        // Filter and update reviews
        const reviewsContainer = this.block.querySelector('.google-reviews__reviews');
        if (reviewsContainer && this.allReviews?.length) {
            const filteredReviews = this.allReviews
                .filter(review => review.rating >= this.minRating)
                .slice(0, 3);
            const reviewsHtml = filteredReviews.map(review => this.createReviewHTML(review)).join('');
            reviewsContainer.innerHTML = reviewsHtml;
        }
    }

    createReviewHTML(review) {
        const starsHtml = [...Array(5)].map((_, index) => `
            <div
                class="${index < review.rating ? 'google-reviews__fullstar' : 'google-reviews__emptystar'}"
            ></div>
        `).join('');
        
        const authorImage = review.profile_photo_url 
            ? `<img src="${review.profile_photo_url}" alt="${review.author_name}" class="google-reviews__avatar" />`
            : `<div class="google-reviews__initials">${review.author_name.charAt(0)}</div>`;

        return `
            <div class="google-reviews__card">
                <div class="google-reviews__author">
                    ${authorImage}
                    <span class="google-reviews__name">${review.author_name}</span>
                </div>
                <div class="google-reviews__stars">
                    ${starsHtml}
                </div>
                <div class="google-reviews__text">${review.text}</div>
            </div>
        `;
    }
}

// Initialize all Google Reviews blocks on the page
function initGoogleReviews() {
    const blocks = document.querySelectorAll('.wp-block-block-builder-by-arc-google-reviews');
    blocks.forEach(block => new GoogleReviewsBlock(block));
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoogleReviews);
} else {
    initGoogleReviews();
}